import type { compose as it } from "../it/compose.ts";

/** Lettura, validazione e importazione dei compose. */
export const compose: typeof it = {
  // Validatore
  "compose.immagineMancante": (p: { servizio: string }) =>
    `service "${p.servizio}" doesn't declare an image. ` +
    "Portman starts stacks from images already available in a registry.",
  "compose.tagMancante": (p: { immagine: string; servizio: string }) =>
    `image "${p.immagine}" of service "${p.servizio}" has no tag. ` +
    "A tag is required: without one, there's no way to know which version is running " +
    "or to roll back to the previous one.",
  "compose.tagMobile": (p: { servizio: string; tag: string }) =>
    `service "${p.servizio}" uses the floating tag "${p.tag}": its content can ` +
    "change without notice, making deploys non-reproducible.",
  "compose.portaDuplicata": (p: { porta: string; protocollo: string; primo: string; secondo: string }) =>
    `host port ${p.porta}/${p.protocollo} is requested by both "${p.primo}" ` +
    `and "${p.secondo}": two services can't listen on the same port.`,
  "compose.portaNonGestita": (p: { servizio: string; porta: number }) =>
    `service "${p.servizio}" exposes port ${p.porta} without a host port: ` +
    "Docker will pick a random one on every start. Use a variable to let Portman manage it.",
  "compose.variabileObbligatoria": (p: { variabile: string }) =>
    `variable "${p.variabile}" is required by the compose but has no value. ` +
    "Set it in the stack environment.",
  "compose.variabileVuota": (p: { variabile: string }) =>
    `variable "${p.variabile}" has no value: the compose will use it empty.`,
  "compose.variabileInutile": (p: { variabile: string; file: string }) =>
    `variable "${p.variabile}" is defined in the environment but not used by the compose. ` +
    `If the application needs it, declare it in the service — "environment: - ${p.variabile}" ` +
    `for this variable alone, "env_file: ${p.file}" for the whole environment.`,

  // Parser
  "compose.vuoto": "the compose file is empty",
  "compose.yamlNonValido": (p: { dettaglio: string }) => `invalid YAML: ${p.dettaglio}`,
  "compose.portaNonValida": (p: { voce: string; valore: string }) => `invalid port in "${p.voce}": ${p.valore}`,
  "compose.portaSenzaTarget": (p: { voce: string }) => `long-syntax port without "target": ${p.voce}`,
  "compose.portsNonElenco": (p: { servizio: string }) => `"ports" of service ${p.servizio} must be a list`,
  "compose.portaNonRiconosciuta": (p: { servizio: string; voce: string }) =>
    `unrecognized "ports" entry in service ${p.servizio}: ${p.voce}`,
  "compose.exposeNonElenco": (p: { servizio: string }) => `"expose" of service ${p.servizio} must be a list`,
  "compose.portmanNonMappa": (p: { servizio: string }) =>
    `"x-portman" of service ${p.servizio} must be a mapping`,
  "compose.portmanChiave": (p: { chiave: string; servizio: string }) =>
    `unknown key "${p.chiave}" under x-portman of service ${p.servizio}`,
  "compose.fissoNonBooleano": (p: { servizio: string }) =>
    `"x-portman.fisso" of service ${p.servizio} must be a boolean`,
  "compose.reteNonRiconosciuta": (p: { servizio: string }) =>
    `"networks" of service ${p.servizio} is not recognized`,
  "compose.servizioNonMappa": (p: { servizio: string }) => `service ${p.servizio} must be a mapping`,
  "compose.radiceNonMappa": "the compose file must contain a mapping of sections",
  "compose.senzaServizi": 'the compose file must declare at least one service under "services"',

  // Rimozione delle porte host
  "compose.porteHost.ripetute": 'declares "ports:" more than once',
  "compose.porteHost.inLinea": "declares its ports inline, on a single line",
  "compose.porteHost.estesa": "uses the long syntax, over several lines",
  "compose.porteHost.forma": "has a shape I can't remove line by line",

  // Importazione
  "compose.import.vuoto": "no containers to import: the project has no services",
  "compose.import.senzaTag": (p: { servizio: string; immagine: string }) =>
    `Service "${p.servizio}" uses image "${p.immagine}" without an explicit ` +
    "tag: add one before starting, because without it there's no way to know which " +
    "version is running or to roll back to the previous one.",
  "compose.import.porte":
    "Host ports were kept as they are, so the address of a service that's already " +
    "running doesn't change. To let Portman manage them, replace them with a variable — " +
    'for example "${PORT_WEB}:80" — and they will be assigned and kept stable over time.',
  "compose.import.dipendenze":
    "Docker doesn't keep the start order of services: if the stack declared dependencies " +
    "with depends_on, you'll need to add them back by hand.",

  // Porte e password
  "compose.poolEsaurito": (p: { inizio: number; fine: number }) =>
    `no free port in the range ${p.inizio}-${p.fine}. ` +
    "Widen the configured pool or free up ports no longer in use.",
  "password.corta": (p: { minimo: number }) => `must be at least ${p.minimo} characters long`,
  "password.comune": "is too common a password",
  "password.ripetuta": "can't be a single repeated character",
};
